import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';

export const GET_EXCEEDING_AMOUNT = 'GET_EXCEEDING_AMOUNT';
export const GET_EXCEEDING_AMOUNT_SUCCESS = 'GET_EXCEEDING_AMOUNT_SUCCESS';
export const GET_EXCEEDING_AMOUNT_FAILED = 'GET_EXCEEDING_AMOUNT_FAILED';

export class GetExceedingAmount implements Action {
  type = GET_EXCEEDING_AMOUNT;

  constructor(public payload: any) {}
}

export class GetExceedingAmountSuccess implements Action {
  type = GET_EXCEEDING_AMOUNT_SUCCESS;

  constructor(public payload: any) {}
}

export class GetExceedingAmountFailed implements Action {
  type = GET_EXCEEDING_AMOUNT_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetExceedingAmount
  | GetExceedingAmountSuccess
  | GetExceedingAmountFailed;
